import classnames from 'classnames'

import { Skeleton } from '../skeleton'

import legacyStyles from './purchaseTypeSelector.module.scss'

import type { PurchaseTypeSelectorShimmerProps } from './purchase-type-selector.types'

export const PurchaseTypeSelectorShimmerLegacy = ({
  showShimmer,
  isFromPdp,
  children,
  showNewPdpDesignV2,
}: PurchaseTypeSelectorShimmerProps) => {
  if (!showShimmer) return children

  return (
    <div
      className={classnames(
        legacyStyles.shimmerWrapper,
        isFromPdp && legacyStyles.adjustedPaddingForMobile,
        showNewPdpDesignV2 && legacyStyles.adjustedPaddingForMobile_noPaddingRight,
      )}
    >
      <div className={legacyStyles.shimmerCard}>
        <Skeleton height={124} fullWidth variant="RECTANGULAR" className={legacyStyles.customSkeletonWrapper} />
      </div>
      <div className={legacyStyles.shimmerCard}>
        <Skeleton height={42} fullWidth variant="RECTANGULAR" className={legacyStyles.customSkeletonWrapper} />
      </div>
    </div>
  )
}
